import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  numberOfBoxes: 0
};

export function BoxHolderReducer(
  state = { boxHolders: [] },
  action
) {
  let currentBoxHolder;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_BOX_HOLDER" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("boxHolders")
      ) {
        currentBoxHolder =
          state.protocolSection.scene.apparatus.boxHolders[
            findIndex(state.protocolSection.scene.apparatus.boxHolders, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_BOX_HOLDER":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("boxHolders")) {
        protocolSection.scene.apparatus.boxHolders = [
          ...protocolSection.scene.apparatus.boxHolders,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.boxHolders = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case "SET_BOX_IN_SCENE":
      //Payload = {inScene}
      let currentBoxHolder2 = protocolSection.scene.apparatus.boxHolders[findIndex(state.protocolSection.scene.apparatus.boxHolders, { id: 1 })];

      if(action.payload.inScene){
        currentBoxHolder2.numberOfBoxes = currentBoxHolder2.numberOfBoxes + 1
      } else {
        currentBoxHolder2.numberOfBoxes = currentBoxHolder2.numberOfBoxes - 1
      }

      protocolSection.scene.apparatus.boxHolders[findIndex(state.protocolSection.scene.apparatus.boxHolders, { id: 1 })] = currentBoxHolder2;
      return { ...state, ...{ protocolSection: protocolSection } };

    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null  && protocolSection.scene.apparatus.hasOwnProperty('boxHolders')) {
        protocolSection.scene.apparatus.boxHolders =
          action.payload.lastState.scene.apparatus.boxHolders;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
